<template>
  <div class="home-index">
    <div class="bk-img">
    </div>
    <div class="header">
      <Header activeMenuIndex="2" @platform="updatePlatform" :disablePltBtn="false"></Header>
    </div>
<!--    <div class="home-1-wrapper">-->
<!--      <div class="home-1" v-loading="loading" v-if="data != null && data.length > 0">-->
<!--        <el-carousel :interval="5000" height="600px" type="card" indicator-position="outside">-->
<!--          <el-carousel-item v-for="(v, index) in data.slice(0, 5)" :key="'item_' + index">-->
<!--            <div class="banner-item">-->
<!--              <div class="banner_detail">-->
<!--                <h3>{{ v.Title }} </h3>-->
<!--                <span v-if="v.owner_name">By: {{  v.owner_name }}</span>-->
<!--                <span ><img class="eth_icon" src="@/assets/img/icon.png" alt="" style="object-fit: contain"/>{{ v.nft_amount }}</span  >-->
<!--&lt;!&ndash;                <div class="ending-time">&ndash;&gt;-->
<!--&lt;!&ndash;                  <span :class="{ closed: Timestatus === 'Closed' }">{{ Timestatus(v.end) }}</span>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--                <div class="progress-container">-->
<!--                  <div class="icon-wraper">-->
<!--                    <img src="@/assets/img/icon-sm.svg" alt="left icon" class="progress-icon" />-->
<!--                    <div class="hover-count">{{ v.l_count }}</div>-->
<!--                  </div>-->
<!--                  <div class="progress">-->
<!--                    <span class="progressing" v-bind:style="'width:' + v.Rate * 100 + '%'" ></span>-->
<!--                  </div>-->
<!--                  <div class="icon-wraper">-->
<!--                    <div class="hover-count">{{ v.r_count }}</div>-->
<!--                    <img src="@/assets/img/icon-k-gray.svg" alt="left icon" class="progress-icon" />-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="to_detail_btn" @click="toDetail(v)">-->
<!--                  <span>{{$t("lang.Join")}}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="img-containerBig">-->
<!--                <img :src="v.Url" alt="" class="background-img" />-->
<!--              </div>-->

<!--            </div>-->

<!--          </el-carousel-item>-->
<!--        </el-carousel>-->
<!--      </div>-->
<!--    </div>-->

    <div class="home-t">
      <ul>
        <li class="opt-title">
<!--          <span>-->
<!--            {{$t("lang.opting")}}-->
<!--          </span>-->
        </li>
        <li>
          <!--          <span>{{ $t("lang.Filter") }}:</span>-->
          <el-select v-model="fliterValue" @change="changeFliter" class="select-box">
            <!-- <el-option :label='$t("lang.AllOption")' :value="1"></el-option>
            <el-option :label='$t("lang.Active")' :value="2"></el-option>
            <el-option :label='$t("lang.Closed")' :value="3"></el-option> -->
            <el-option :label='$t("lang.Ongoing")' :value="1"></el-option>
            <el-option :label='$t("lang.Ended")' :value="2"></el-option>
          </el-select>
        </li>
        <li>
          <!--          <span>{{ $t("lang.SortedBy") }}:</span>-->
          <el-select v-model="sortByValue" @change="changeSort" class="select-box">
            <el-option :label='$t("lang.NumberParticipants")+":"+$t("lang.LowToHigh")' :value="1"></el-option>
            <el-option :label='$t("lang.NumberParticipants")+":"+$t("lang.HighToLow")' :value="2"></el-option>
            <el-option :label='$t("lang.EndTime")+":"+$t("lang.LowToHigh")' :value="3"></el-option>
            <el-option :label='$t("lang.EndTime")+":"+$t("lang.HighToLow")' :value="4"></el-option>
            <el-option :label='$t("lang.totalAmount")+":"+$t("lang.LowToHigh")'  :value="5" ></el-option>
            <el-option :label='$t("lang.totalAmount")+":"+$t("lang.HighToLow")'   :value="6" ></el-option>
            <!-- <el-option :label='$t("lang.Recently")' :value="7"></el-option> -->
          </el-select>
        </li>
      </ul>
    </div>
    <div class="nodata" v-if="data == null || data.length == 0">
      <img :src="require('@/assets/img/nodata_opting.png')" class="img" />
    </div>
    <li  class="home-box-3"  v-loading="loading" v-if="data != null && data.length > 0" >

      <ul class="card">
        <li v-for="(v, index) in data" :key="'item_' + index">
          <pick-martket-card :v_data = "v" :chain = "chain"></pick-martket-card>
        </li>
      </ul>
    </li>
    <connectMetamask ref="showMetamask"></connectMetamask>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/header.vue";
// import Footer from "../../components/footer.vue";
import request from "../../services/request";
import {BASE_V_API,countDownTime} from "@/config.js"
import ad from "../../utils/web3Helper.js";
import moment from "moment";
import { mapState } from "vuex";
import PickMartketCard from "@/views/modules/pickMartketCard.vue";
import Footer from "../../components/footer.vue";
export default {
  name: "home",
  data() {
    return {
      chain: "",
      sort: 1, //1: 按价格排序 2：总参与人数 3：阵营差值 4：我收藏的(key 需要传入当前地址) 5；即将结束的 6:价格倒叙
      data: [],
      activeName: "1",
      isCollected: false,
      base: "",
      loading: false,
      timeData: [],
      fliterValue: 1, //筛选的值
      sortByValue: 2, //排序的值
    };
  },
  computed: {
    ...mapState(["address"]),
  },
  created() {
    this.loadData();
  },
  mounted() {
    // this.changeGrid();
    // window.addEventListener('load', this.changeGrid);
    // window.addEventListener('resize', this.changeGrid);
  },
  destroyed() {
    // window.removeEventListener('load', this.changeGrid);
    // window.removeEventListener('resize', this.changeGrid);
  },
  methods: {
    updatePlatform() {
      this.platform = JSON.parse(sessionStorage.getItem("selectedPlatform"));
      this.loadData();
    },
    Timestatus() {
      let endTime = this.v_data.start_time * 1000 + countDownTime * 1000;
      let time = endTime - this.currentTime;
      let status;
      if (time < 0) {
        status = this.$t("lang.Closed");
      } else {
        let hours = Math.floor(time / (1000 * 60 * 60));
        let minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((time % (1000 * 60)) / 1000);
        status = (hours > 9 ? hours : "0" + hours) + ":" + (minutes > 9 ? minutes : "0" + minutes) + ":" + (seconds > 9 ? seconds : "0" + seconds);
      }
      return status;
    },
    changeGrid() {
      const cards = document.querySelectorAll('.home-box-3 .card li');
      const minW = 225;
      let screenWidth = window.innerWidth * 0.9;
      let nOfCards = Math.max(1, Math.floor(screenWidth / (minW+15))); // Ensure at least one card per row
      let cardWidth = (screenWidth - (nOfCards) * 15)/ nOfCards;

      if (cardWidth > 500) {
        cardWidth = 500;
      } else if (cardWidth < minW) {
        cardWidth = minW;
      }

      // let totalMargin = screenWidth - ((cardWidth+15) * nOfCards);
      let marginRight = 15;
      console.log('screenWidth', screenWidth, 'nOfCards', nOfCards, 'cardWidth', cardWidth, 'marginRight', marginRight);
      cards.forEach((card, index) => {
        card.style.width = cardWidth + 'px';
        // card.style.marginRight = (index + 1) % nOfCards === 0 ? '0' : marginRight + 'px';
        card.classList.remove('last-in-row');
        if ((index + 1) % nOfCards === 0) {
          card.classList.add('last-in-row');
        }
      });
    },

    changeFliter(target) {
      this.fliterValue = target;
      this.loadData();
    },
    changeSort(target) {
      this.sortByValue = target;
      this.loadData();
    },
    toDetail(item) {
      console.log("gotoDetail", item);
      this.$router.push({ name: "nftDetail", query: { tokenID: item.asset_id,id:item.id } });
    },
    addCollect: function (item) {
      let token = sessionStorage.getItem("Token");
      if (this.address == "") {
        this.$refs.showMetamask.show = true;
      } else if (!token) {
        sessionStorage.setItem("iSsignature", false);
        this.getSign();
      } else {
        var para = {
          address: this.address,
          token_id: item.TokenID,
        };
        if (item.IsCollect == true) {
          request.delMyCollect(para).then((response) => {
            if (response.code == 200) {
              item.IsCollect = !item.IsCollect;
              // this.loadData();
            }
          });
        } else {
          request.addMyCollect(para).then((response) => {
            if (response.code == 200) {
              item.IsCollect = !item.IsCollect;
              // this.loadData();
            }
          });
        }
      }
    },
    loadData() {
      this.loading = true;
      const params = {
        // key: this.address || "",
        page: 1,
        page_size: 10000,
        status: this.fliterValue,
        sort: this.sortByValue,
        typa:2
      };
      console.info("load data by param ", params)
      request.getOpting(params).then((response) => {
        if (response.code == 200) {
          this.data = response.data;
          this.data.forEach((item, index) => {
            // this.data[index].Amount = ad.fromWei(this.data[index].Amount);
            var ac = parseInt(item.l_count);
            var dc = parseInt(item.r_count);
            if (ac == 0 && dc == 0) {
              this.data[index].Rate = 0.5;
            } else {
              this.data[index].Rate = ac / (ac + dc);
            }
            // this.data[index].UpdatedAt = moment(
            //   this.data[index].UpdatedAt
            // ).format("YYYY-MM-DD");
            // let arr = item.Path.split("/");
            // let fileName = arr[arr.length - 1];
            // let fileSplit = fileName.split(".");
            // let suffixType = fileSplit[fileSplit.length - 1];
            // if (suffixType == "mp4") {
            //   item.isVideo = true;
            // } else {
            //   item.isVideo = false;
            // }
          });
          this.loading = false;
        } else {
          this.$message.error(response.message);
        }
      });
    },
  },
  components: {
    PickMartketCard,
    Header,
    Footer,
  },
};
</script>

<style lang="less" scoped>
.select-box{
  border-radius: 10px;
  background-color: #0aa0ff;
}
.bk-img {
  background-image: url("../../assets/img/home/bg-image-1_1bg-image-1.avif");
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 120px;
  padding-bottom: 350px;
  width: 100vw;
  height: 600px;
  position: absolute;
  top: -40px;
  left: 0;
  z-index: -100;
}
.bk-img::after {
  content: "";
  position: absolute;
  top: 300px;
  left: 0;
  width: 100%;
  height: 50%;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 100%);
}

.home-1-wrapper{
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  .home-1 {
    width: 1200px;
    height: 600px;
    background: transparent;
    //display: flex;
    //justify-content: center;
    //align-items: center;
    el-carousel {

      el-carousel-item {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .banner-item{
      &:hover{
        .background-img{
          transform: scale(1.05);
        }
        .to_detail_btn{
          background-color: #FFFFFF;
          span {
            background: linear-gradient(90deg, #f26aff, #7d6fff);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
      }
    }
    .img-containerBig {
      position: absolute;
      border-radius: 25px;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
      transition: all 0.2s ease;
      .background-img {
        transition: all 0.2s ease;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .banner_detail {
      background-color: rgba(255, 255, 255, 0.52);
      backdrop-filter: blur(10px);
      z-index: 10;
      position: absolute;
      height: 100px;
      bottom: 0px;
      left: 0px;
      color: black;
      width: 100%;
      border-bottom-left-radius: 25px;
      border-bottom-right-radius: 25px;
      padding: 15px;

      span{
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 600;
        img{
          width: 24px;
          height: 24px;
          margin-right: 5px;
        }
      }
    }
    .progress-container {
      display: flex;
      justify-content: center;

      .icon-wraper{
        position: relative;
        .hover-count{
          display: none;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 18px;
          color: #fff;
          //background-color: #00a000;
        }
        //&:hover .progress-icon {
        //  opacity: 0;
        //}
        //&:hover .hover-count {
        //  display: block;
        //}
        .progress-icon {
          width: 25px;
          height: 25px;
          margin-left: 10px;
          margin-right: 10px;
          transition: opacity 0.2s;
        }
      }
      .ending-time{
        position: absolute;
        top: 0px;
        left: 0px;
      }
      .progress {
        margin-top: 5px;
        margin-bottom: 5px;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-self: center;
        border-radius: 8px;
        border: 1px solid #7d6fff;
        span {
          height: 15px;
          display: inline-block;
          background: #7d6fff;
          border-radius: 7.5px;
          //border-top-left-radius: 7.5px;
          //border-bottom-left-radius: 7.5px;
        }
      }
      .progress-icon:hover{
        opacity: 0;
      }
      .progress-icon:hover + .hover-count{
        display: block;
      }
    }
    .to_detail_btn{
      position: absolute;
      top: 15px;
      right: 15px;
      color: black;
      background-color: rgba(255, 255, 255, 0.52);
      backdrop-filter: blur(10px);
      padding: 10px 20px;
      border-radius: 5px;
      cursor: pointer;
      span{
        font-size: 26px;
        font-weight: 500;
      }
    }
    h3 {
      font-size: 24px;
      color: black;
    }
  }
}



.home-index {
  min-height: 100%;
  position: relative;

  .home-t {
    width: 1200px;
    margin: auto;
    margin-top: 28px;
    .opt-title {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      span {
        font-size: 30px;
      }
    }
    ul {
      display: flex;
      justify-content: flex-end;
      li {
        margin-left: 10px;
        .el-select {
          width: 180px;
        }
      }
    }
    span {
      font-size: 14px;
      font-weight: 400;
      color: #12022f;
      padding: 0 10px;
    }
    div {
      font-size: 16px;
      text-align: center;
      font-weight: 400;
      color: rgba(196, 192, 203, 1);
      i {
        margin-left: 10px;
      }
    }
    .active {
      color: rgba(115, 36, 254, 1);
      border: 1px solid rgba(115, 36, 254, 1);
    }
    .home-t-b {
      display: flex;
      justify-content: center;
      align-items: center;
      border: #c4c0cb 1px solid;
      padding: 9px 22px;
      border-radius: 6px;
      margin-right: 15px;
      cursor: pointer;
      .text {
        font-weight: 400;
      }
      .sort-flag {
        display: flex;
        margin-left: 10px;
        &:before {
          content: "";
          display: block;
          background: url("~@/assets/img/sort-item-gray.svg") no-repeat center
            center/9px 16px;
          width: 9px;
          height: 16px;
        }
        &:after {
          content: "";
          display: block;
          background: url("~@/assets/img/sort-item-gray.svg") no-repeat center
            center/9px 16px;
          width: 9px;
          height: 16px;
          transform: rotate(180deg);
        }
      }
      &.active,
      &.esc {
        border-color: #7324fe;
        .text {
          color: #7324fe;
        }
        .sort-flag {
          &:before {
            background-image: url("~@/assets/img/sort-item.svg");
          }
        }
      }
      &.active,
      &.desc {
        border-color: #7324fe;
        .text {
          color: #7324fe;
        }
        .sort-flag {
          &:after {
            background-image: url("~@/assets/img/sort-item.svg");
          }
        }
      }
      &:hover {
        border-color: #7324fe;
        .text {
          color: #7324fe;
        }
        .sort-flag {
          &:before,
          &:after {
            background-image: url("~@/assets/img/sort-item.svg");
          }
        }
      }
    }
  }
  .home-box-3 {
    display: flex;
    //justify-content: space-between;
    justify-content: flex-start;
    flex-wrap: wrap;
    width: 1200px;
    margin: auto;
    min-height: calc(100vh - 417px);
    .card {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      width: 100%;
      margin: 15px 0;
      li {
        width: 24%;
        background-color: #F8F8FF;
        border-radius: 5%;
        overflow: hidden;
        margin-right: 1.25%;
        margin-bottom: 15px;
        cursor: pointer;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 2px 0 rgba(0, 0, 0, 0.1);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        .img-container {
          height: 288px;
          background: #F8F8FF;
          overflow: hidden;
          .el-image {
            height: 100%;
            width: 100%;
            border-radius: 2px;
            transition: all 0.2s ease;
            &:hover {
              // transform: translateY(-8px);
              transform: scale(1.1);
            }
          }
        }
        &:hover {
          transform: translateY(-3px);
          box-shadow: 2px 8px 16px 2px rgba(0, 0, 0, 0.3), 1px 12px 4px 1px rgba(0, 0, 0, 0.2);
          .img-container {
            img {
              transform: translateY(-8px);
            }
          }
        }
        h4 {
          justify-self: center;
          width: 90%;
          font-size: 15px;
          display: flex;
          justify-content: space-between;
          line-height: 28px;
          & > span:last-child {
            font-size: 13px;
            font-weight: normal;
          }
        }
        .gray {
          color: #666;
        }
        p {
          display: flex;
          justify-self: center;
          width: 90%;
          justify-content: space-between;
          line-height: 24px;
          & > span {
            display: flex;
            align-items: center;
            font-weight: 600;
            font-size: 14px;
          }
          .Owner {
            color: #666;
            font-weight: 500;
          }
        }
        img {
          width: 20px;
        }
        //票数 进度条
        .progress-container {
          display: flex;
          justify-content: center;
          .icon-wraper{
            position: relative;
            .hover-count{
              display: none;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              font-size: 18px;
              color: #000;
              //background-color: #00a000;
            }
            &:hover .progress-icon {
              opacity: 0;
            }
            &:hover .hover-count {
              display: block;
            }
            .progress-icon {
              width: 25px;
              height: 25px;
              margin-left: 10px;
              margin-right: 10px;
              transition: opacity 0.2s;
            }
          }
          p {
            span {
              color: #0092bf;
              font-size: 16px;
            }
            .defuse-count {
              color: #e16b2e;
            }
          }
          .progress {
            margin-top: 5px;
            margin-bottom: 5px;
            width: 70%;
            height: 15px;
            display: flex;
            align-items: center;
            justify-self: center;
            background: #F8F8FF;
            border-radius: 8px;
            border: 1px solid #613659;
            span {
              height: 15px;
              display: inline-block;
              background: #613659;
              border-radius: 7.5px;
              //border-top-left-radius: 7.5px;
              //border-bottom-left-radius: 7.5px;
            }
          }
          .progress-icon:hover{
            opacity: 0;
          }
          .progress-icon:hover + .hover-count{
            display: block;
          }
        }
        //状态和收藏爱心
        .status-Collect {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 0px;
          justify-self: center;
          width: 88.5%;
          .el-icon-alarm-clock{
            align-self: center;
            transform: scale(1.3);
            display: inline-block;
          }
          img {
            width: 25px;
            //transform: translateY(40px);
            //transition: all 0.5s ease;
          }
          p {
            position: relative;
            bottom: 0;
            width: 100%;
            text-align: center;
            span {
              text-align: center;
              color: #211522;
              &.closed {
                color: #333;
              }
            }
          }
        }
        //&:hover {
        //  .status-Collect {
        //    img {
        //      filter: opacity(0.7);
        //      transform: translateY(0px);
        //      &:hover {
        //        filter: opacity(1);
        //      }
        //    }
        //  }
        //}
      }
      li:nth-child(4n + 4) {
        margin-right: 0;
      }
    }
  }
}
.actions {
  display: flex;
  justify-content: space-between;
  padding: 15px 0;
  .btn {
    border-radius: 10em;
    height: 44px;
    line-height: 24px;
    padding: 10px 20px;
    border: transparent 1px solid;
    text-align: center;
    min-width: 120px;
    cursor: pointer;
    &.nft-btn {
      background: #ffdda9;
      color: #000;
      font-size: 16px;
      border-color: #ffdda9;
    }
    &.nft-btn-default {
      border-color: #dcdcdc;
    }
    &:hover {
      opacity: 0.6;
    }
  }
}
.sell-action {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  .icon {
    width: 46px;
    height: 46px;
    margin-right: 20px;
  }
  .sellprice {
    background: url("~@/assets/img/shopcart.svg") no-repeat left center/15px
    14px;
    padding-left: 25px;
    font-size: 14px;
  }
  .nft-price {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .circle-nft {
      background: #f1f1f1 url("~@/assets/img/nft.svg") no-repeat center
        center/60% 60%;
      width: 28px;
      height: 28px;
      border-radius: 50%;
    }
    .num {
      font-size: 28px;
      color: #841ae9;
      margin-left: 10px;
    }
  }
}
.nodata {
  min-height: calc(100vh - 300px);
  .img {
    width: 357px;
    height: 281px;
    display: block;
    margin: 0px auto 0;
  }
}



</style>
<style>
.el-select-dropdown__wrap {
  max-height: 380px;
}
</style>